<template>
    <div >
        <div class="row " >
            <div style="" class="col-md-4  otherInfoLeft2   bgColorLeft ">
                <div style="" class="leftTitle mt-2 clearfix text-left">
                    <!--<li></li>-->
                    {{$t("theend.1")}}:
                </div>
            </div>
            <!---style="margin:50px 0 0 0; clear:both; border: solid 1px orange;"--->
            <div class="col-md-8  otherInfoRight2 theEnde" >
                <div class="mt-2 clearfix text-left rightTitle">
                    {{$t("theend.2")}}
                </div>
                <div style="" class="rightLine mt-1 clearfix ">

                    <div class="clearfix mt-4 bold text-left">
                        {{$t("theend.3")}}
                    </div>

                    <end-info-set   v-for="(content, i) in oContent" 
                                    :key="i" 
                                    :record="content"/>
                    
                </div>
            </div>    
        </div>
    </div>
</template>

<script>
    import EndInfoSet from "@/components/EndInfoSet.vue"
    import End from "@/assets/JSON/End" 
    export default {
        components: {
            EndInfoSet
        },
        data() {
            return {
                oContent: End
            }
        },
    }
</script>

<style lang="scss" scoped>
.endeClass {
    clear:both;
}
</style>